<template> <!--TO DO! change hard coded lookup to api form lookup-->
    <div>
        <div class="row" v-if="Plan!=='EPF'">
            <div class="col">
                <q-toggle
                    v-model="Form.SmartSave"
                    label="Smart Save"
                />
            </div>
        </div>
        <div class="row">
            <div class="col q-pt-lg" >
                <q-input 
                outlined 
                :prefix= "Currency"
                @blur="InvAmount=false"
                v-model="Form.InvAmount" 
                label="Investment Amount" 
                v-if="Form.SmartSave === false && InvAmount===true"
                :rules="[ val => val !== '' && val !== 0 && val > Form.MinAddAmount || 'Amount must be more than ' + Form.MinAddAmount]"
                />
                
                <q-input 
                outlined 
                :prefix= "Currency"
                @focus="InvAmount=true"
                :value="Form.InvAmount| thousandSeparator" 
                label="Investment Amount"
                v-if="Form.SmartSave === false && InvAmount===false" 
                />
                
                <q-input 
                outlined 
                :prefix="Currency"
                @blur="InvAmount=false"
                v-model="Form.InvAmount" 
                label="Direct Debit Amount" 
                v-if="Form.SmartSave === true && InvAmount===true"
                :rules="[ val => val !== '' && val !== 0 && val > Form.MinAddAmount || 'Amount must be more than ' + Form.MinAddAmount]"
                />

                
                <q-input 
                outlined 
                :prefix="Currency"
                @focus="InvAmount=true"
                :value="Form.InvAmount| thousandSeparator" 
                label="Direct Debit Amount" 
                v-if="Form.SmartSave === true && InvAmount===false"
                />
                <br>
            </div>
        </div>
        <div class="row" v-if="StoreStateCD.Account.AccountType!=='PRS'">
            <div class="col">
                <q-input 
                outlined v-model="Form.SalesCharge" 
                label="Sales Charge" suffix="%"
                :rules="[ val => val <= MaxSalesCharge && val !== '' && val >= 0 || 'Must not more than ' + MaxSalesCharge + '%']" 
                />
            </div>
        </div>
        <div v-if="Form.SmartSave === true" class="q-pt-lg">
            <div class="row">
                <div class="col">
                    <q-input label="Start Date" outlined v-model="Form.SmartSaveStartDate" mask="date">
                        <template v-slot:append>
                        <q-icon name="event" class="cursor-pointer">
                            <q-popup-proxy ref="SmartSaveStartDate" transition-show="scale" transition-hide="scale">
                            <q-date minimal v-model="Form.SmartSaveStartDate" @input="() => $refs.SmartSaveStartDate.hide()" />
                            </q-popup-proxy>
                        </q-icon>
                        </template>
                    </q-input>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col">
                <q-input label="End Date" outlined v-model="Form.SmartSaveEndDate" mask="date">
                    <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy ref="SmartSaveEndDate" transition-show="scale" transition-hide="scale">
                        <q-date minimal v-model="Form.SmartSaveEndDate" @input="() => $refs.SmartSaveEndDate.hide()" />
                        </q-popup-proxy>
                    </q-icon>
                    </template>
                </q-input>
                </div>
            </div> 
            <br>
            <div class="row">
                <div class="col">
                <a class="text-caption">Mode of Frequency</a><br> 
                <q-btn-toggle
                    v-model="Form.ModeOfFrequency"
                    toggle-color="primary"
                    :options="[
                    {label: 'Monthly', value: 'Monthly'},
                    {label: 'Yearly', value: 'Yearly'}
                    ]"
                />
                </div>
            </div> 
            <br>
            <div class="row">
                <div class="col"> 
                <a class="text-caption">Date of Deduction</a><br> 
                <q-option-group
                    v-model="Form.DateOfDeduction"
                    :options="[
                    {label:'5th',value:'5th'},
                    {label:'20th',value:'20th'}
                    ]"
                    color="primary"
                    type="checkbox"
                />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import store from '../store';
export default {
    name: 'FundTransactionBuy',
    components: {
        
    },
    props : ["Plan","MinAddAmount","MaxSalesCharge","Currency"],
    
    
    data () {
        return {
            Form : {
                InvAmount : 0,
                SalesCharge : 0,
                SmartSave : false,
                SmartSaveStartDate : '',
                SmartSaveEndDate : '',
                ModeOfFrequency : '',
                DateOfDeduction : [],
                MinAddAmount : 0
            },
            InvAmount : false,
            StoreStateCD : store.state.CD
        }
    },
    mounted(){
        this.Form.InvAmount = this.MinAddAmount;
        this.Form.SalesCharge = this.MaxSalesCharge;
    },
    methods:{
    ...mapActions(["UpdateFundList","GetListOfFund","FilterFundOptions"]),
    FilterFund (val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.UpdateFundList(this.FundOptionsFiltered.filter(v => v.label.toLowerCase().indexOf(needle) > -1))
      })
    },
    GetFund(){
      this.FilterFundOptions({
        SophisticatedInvestor : this.StoreStateCD.CustomerDetails.SophisticatedInvestor,
        RiskProfile : this.StoreStateCD.SAT.Group,
        Disagree : true,
        Plan : this.Plan
      });
    },
    PopulateFundDetails(Item){
      this.Form.Amount = Item.minaddamount;
      this.Form.MinAddAmt = Item.minaddamount;
      this.Form.SalesCharge = Item.SalesCharge;
      if(Item.ProductAssetClass === 'Cash Management Solution (CMS)' || Item.ProductAssetClass === 'CMS (Close-ended)'){
        this.$q.dialog({
            title: 'Message',
            message: 'Kindly note that only FPX payment can be processed. For other payment mode, kindly proceed with manual form submission.',
        })
      }
    }
  },
  computed:{
    ...mapState({
      FundOptions: state => state.Product.FundOptions,
      FundOptionsFiltered: state => state.Product.FundOptionsFiltered,
      FundList: state => state.Product.FundList
    }),

  },
  filters: {
    thousandSeparator: function(value) {
        if (value !== '' || value !== undefined || value !== 0  || value !== '0' || value !== '') {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
            return value;
        }
    }
  } 
}
</script>